import ListGroup from "./controls/ListGroup";
import ListGroupObjectItem from "./controls/ListGroupObjectItem";
import LongTextValue from "./controls/LongTextValue";
import ListValue from "./controls/ListValue";
import MeasureValue from "./controls/MeasureValue";
import { useTranslation } from "react-i18next";
import { ProductoSchema } from "../data/ProductoSchema";

export function ProductoElaboradoList({ value, select, remove, disabled }) {
  const { t } = useTranslation();
  return (
    <ListGroup>
      {value?.map((productoElaborado, index) => {
        const isInvalid = !ProductoSchema.isValidSync(productoElaborado, {
          abortEarly: false,
        });
        return (
          <ListGroupObjectItem
            key={productoElaborado.orden}
            index={index}
            value={productoElaborado}
            indexLabel={t("producto.orden")}
            className={isInvalid ? "has-error" : ""}
            deletable
            onDelete={(event) => {
              event.preventDefault();
              remove(index);
            }}
            editable
            onEdit={(event) => {
              event.preventDefault();
              select(index);
              document.getElementById("productosElabrorados").scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }}
            disabled={disabled}
          >
            {({ value }) => (
              <>
                <LongTextValue
                  label={t("producto.nombre")}
                  value={value?.nombre}
                />
                <ListValue
                  label={t("producto.operacionesUnitarias")}
                  value={value?.operacionesUnitarias}
                  labelAttr="nombre"
                />
                <MeasureValue
                  label={t("producto.cantidad")}
                  value={value?.cantidad}
                />
              </>
            )}
          </ListGroupObjectItem>
        );
      })}
    </ListGroup>
  );
}
